import { Component, OnInit } from '@angular/core';
import { BaseComponent } from 'app/base/base.component';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Items } from 'app/core/models/items';
import { TranslateService } from '@ngx-translate/core';
import { NotifMessageService } from 'app/core/services/notifmessage.service';
import { PosReport } from 'app/core/models/posReport';
import { PosReportingServiceService } from 'app/core/services/pos-reporting-service.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-pos-evolution-reports',
  templateUrl: './pos-evolution-reports.component.html',
  styleUrls: ['./pos-evolution-reports.component.css']
})
export class PosEvolutionReportsComponent extends BaseComponent implements OnInit {

  posEvolutionReportForm: FormGroup;
  periodSub: Subscription;
  subscription: Subscription;

  isLoading: boolean;
  period: number = 12;
  periodItems: Array<number> = Array<number>(3, 6, 12);
  posEvolutionReport: Items<PosReport>;
  fromDate: Date;
  reportData: number[];
  reportLabel: string[];
  reportTitle: string;

  criteria = {
    windowBegin: this.getFromDate(this.period),
    windowEnd: new Date()
  };
  displayedColumns = ['month','year','posCount'];

  constructor(
    private formBuilder: FormBuilder,
    private translate: TranslateService,
    private notifService: NotifMessageService,
    private posReporingService: PosReportingServiceService,
    router: Router) { super(router); }

  ngOnInit() {
    this.posEvolutionReportForm = this.formBuilder.group({
      period: new FormControl(this.period, Validators.required)
    });

    this.getPosEvolutionByPeriod();

    this.periodSub = this.posEvolutionReportForm.get("period").valueChanges.subscribe(val => {
      if (this.posEvolutionReportForm.get("period").valid) {
        this.period = val;
        this.criteria.windowBegin = this.getFromDate(val);
        this.getPosEvolutionByPeriod();
      }
    });
  }

  getPosEvolutionByPeriod(): void {
    this.reportTitle = this.translate.instant("POS_NUMBER_EVOLUTION");
    this.isLoading = true;
    this.posReporingService.getPosEvolutionByPeriod(this.criteria).subscribe(
      items => {
        this.posEvolutionReport = items;
        this.reportLabel = items.map(items => this.getMonthName(items.month) + " " + items.year);
        this.reportData = items.map(items => items.pointOfServiceCount);
        this.isLoading = false;
        if (items.empty) {
          this.notifService.notifyInfo('EMPTY_RESULT');
        }
      });
  }

  getMonthName(month: number): string {
    let monthName = this.monthMap.get(month);
    return this.translate.instant(monthName);
  }

  getFromDate(period: number): Date {
    this.fromDate = new Date();
    this.fromDate.setMonth(this.fromDate.getMonth() - period);
    return this.fromDate;
  }

  isActive(posEvolutiontatus): boolean {
    if (posEvolutiontatus == "ACTIVE")
      return true;
    return false;
  }

  date() {
    let frDateFormat = "dd MMM y";
    let usDateFormat = "MMM dd y";
    if (this.translate.currentLang == "fr_FR")
      return frDateFormat;
    else
      return usDateFormat;
  }

  locale() {
    if (this.translate.currentLang == "fr_FR")
      return "fr_FR";
    else
      return "en_US";
  }



  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.periodSub) {
      this.periodSub.unsubscribe();
    }
  }

}
